/// <amd-module name="Agile/ArtifactPicker/Redux/AgileArtifactPickerModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";

export const AgileArtifactPickerModule: ISagaModule<any> = {
    id: "agile-artifact-picker-bundle"
};
